import { render, staticRenderFns } from "./GChatBrandInfoSp.vue?vue&type=template&id=e7b4b9e2&scoped=true&"
import script from "./GChatBrandInfoSp.vue?vue&type=script&lang=ts&"
export * from "./GChatBrandInfoSp.vue?vue&type=script&lang=ts&"
import style0 from "./GChatBrandInfoSp.vue?vue&type=style&index=0&id=e7b4b9e2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e7b4b9e2",
  null
  
)

export default component.exports